// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import FlexWrapContainer from "@insite/content-library/Widgets/Brand/FlexWrapContainer";
import { productCarouselProductCondensedStyles } from "@pace/Overrides/Components/ProductCarouselProductCondensed";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, ellipsis, mergeWithCss, partNumberSharedStyles, sharedBadgeStyle } from "@pace/XDL/Utilities";
import { css } from "styled-components";

productCarouselProductCondensedStyles.container = {
    gap: 0,
    offsetCss: css`
        flex-direction: column;
        flex: 1;
        max-width: 100%;
        width: 100%;
        flex-wrap: nowrap;
        row-gap: 12px;
    `,
};
productCarouselProductCondensedStyles.productDescriptionStyles = {
    ...mergeWithCss(productCarouselProductCondensedStyles.productDescriptionStyles, {
        productDetailLink: {
            typographyProps: {
                size: 12,
                lineHeight: "14px",
                weight: fontConfig.weight.bold,
                css: css`
                    &&& {
                        margin-bottom: 4px;
                        color: ${color("common.black")};
                        ${ellipsis(2)}
                    }
                `,
            },
        },
        productDetailDescription: {
            css: css`
                margin-bottom: 2px;
            `,
        },
    }),
};

productCarouselProductCondensedStyles.productPartNumbersStyles = {
    ...mergeWithCss(productCarouselProductCondensedStyles.productPartNumbersStyles, partNumberSharedStyles),
};

productCarouselProductCondensedStyles.productDetailsGridItem = {
    width: 9,
    css: css`
        max-width: calc(100% - 91px - 12px);
        flex-direction: column;
        padding: 0;
        height: 100%;
    `,
};

productCarouselProductCondensedStyles.productBrandWrapper = {
    css: css`
        display: flex;
    `,
};

productCarouselProductCondensedStyles.productBrandStyles = {
    nameLink: {
        typographyProps: {
            size: 10,
            lineHeight: "11px",
            weight: fontConfig.weight.bold,
        },
    },
};

productCarouselProductCondensedStyles.imageGridItem = {
    width: 3,
    css: css`
        flex-direction: column;
        flex: 1;
        padding: 0;
        width: 91px;
        max-width: 91px;
        img {
            width: 91px;
            height: 91px;
        }
        a:hover,
        a:focus {
            border: none;
        }
    `,
};

productCarouselProductCondensedStyles.imageInfoContainer = {
    width: 12,
    css: css`
        display: flex;
        gap: 12px;
        flex-basis: auto;
    `,
};

productCarouselProductCondensedStyles.condensedActionsTemplateGridItem = {
    width: 12,
    css: css`
        &&& {
            flex-grow: 1;
        }
    `,
};

productCarouselProductCondensedStyles.productBadgesStyles = {
    text: {
        ...sharedBadgeStyle,
    },
    image: {
        container: {
            // Align images with end of text-badges under product image
            css: css`
                display: flex;
                width: 100%;
                justify-content: end;
                margin-top: auto;
                ${FlexWrapContainer} {
                    gap: 4px;
                    display: flex;
                    justify-content: end;
                    margin-top: auto;
                }
            `,
        },
        imageItem: {
            // Badge image container
            css: css`
                flex: 1;
                padding: 0;
                width: 24px;
                max-width: 24px;
                height: 24px;
            `,
        },
    },
};

productCarouselProductCondensedStyles.overlayBadgeStyles = {
    badgeText: {
        ...sharedBadgeStyle.badgeText,
    },
    ...sharedBadgeStyle.badge,
};
